import React from "react";
import { css } from "@emotion/react";
import { CometChat } from "@cometchat-pro/chat";
import { MsgPosition } from "components/chat/types";
import Sender from "components/chat/shared/Sender";
import TimeStamp from "components/chat/shared/TimeStamp";
import { bubbleStyle } from "components/chat/shared/BubbleUtil";

// mui
import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import ErrorIcon from "@mui/icons-material/Error";

const style = {
  msgBox: css`
    border-radius: 12px;
    padding: 8px 16px;
    font-size: 0.9rem;
    background-color: ${grey[100]};
  `,
  msg: css`
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
    text-align: left;
  `,
};

type BubbleDeletedProps = {
  msg: CometChat.BaseMessage;
  position: MsgPosition;
};
const BubbleDeleted: React.FC<BubbleDeletedProps> = (props) => {
  const { msg, position } = props;

  return (
    <Box css={bubbleStyle.root(position)}>
      <Box css={bubbleStyle.child}>
        <Box css={bubbleStyle.box(position)}>
          <Sender sender={msg.getSender()} />
        </Box>
        <Box css={style.msgBox}>
          <ErrorIcon />
          <p css={style.msg}>this message deleted</p>
        </Box>
        <Box css={bubbleStyle.box(position)}>
          <TimeStamp msg={msg} />
        </Box>
      </Box>
    </Box>
  );
};

export default BubbleDeleted;
